import { config as shopsConfig } from './shops.config';
import { config as aboutYouConfig } from './about-you.config';
import { config as completeConfig } from './complete-page.config';
import { config as pathConfig } from './path.config';
import { config as selectDateConfig } from './select-date.config';
import { config as reviewConfig } from './review.config';
import { config as remoteConfig } from './remote.config';
import { EDIT_PROGRESS_BAR_ITEMS, PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { getAppointmentsDetails } from './analytics.config';
import { services } from '../../services.constant';
import { createHeadline } from './headline.config';

const questionsSectionsConfig = [
  {
    key: undefined,
    title: 'Additional information',
    dataTest: 'AdditionalInformation',
  },
];

export const config = {
  ...shopsConfig,
  ...aboutYouConfig,
  ...completeConfig,
  ...pathConfig,
  ...selectDateConfig,
  ...reviewConfig,
  serviceName: services.HOME_SERVICES.name,
  remote: remoteConfig,
  PROGRESS_BAR_ITEMS,
  EDIT_PROGRESS_BAR_ITEMS,
  getAppointmentsDetails,
  partnerTitle: 'Advisor',
  isPartnerSelectionEnabled: false,
  questionsSectionsConfig,
  headlineTitle: createHeadline,
  treatDropdownQuestionAsChoice: true,
};
